import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'
// import { Message, Spin } from 'view-design'

const state = {
  ...restful.states('stock'),
  stocks_all: []
}

const getters = {
  ...restful.getters('stock'),
  stocks_all: (state) => state.stocks_all
}

const actions = {
  ...restful.actions('stocks'),
  async all_index ({ commit }, params) {
    const response = await axios.get('stocks/all_index', { params })
    commit('stocks_all', response.data)
  }
}

const mutations = {
  ...restful.mutations('stock'),
  stocks_all (state, stocks_all) {
    state.stocks_all = stocks_all
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
